import React from 'react';

import { UploadOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';

import { LitigationAction, LitigationStatus } from '../types';
import { LitigationIcon } from '@/components/icons/LitigationIcon';

const commonLitigationItem = (
  text: string,
  key: LitigationAction,
  onItemClick: (action: LitigationAction) => void
) => (
  <Flex align="center" gap=".375rem" onClick={() => onItemClick(key)}>
    <LitigationIcon height={16} width={16} />
    <Typography>{text}</Typography>
  </Flex>
);

export const getDropdownItems = (
  handleExport: (id: string) => void,
  id: string,
  litigationStatus: LitigationStatus | null,
  onItemClick: (action: LitigationAction) => void
) => {
  const exportDataItem = {
    key: '1',
    label: (
      <Flex align="center" gap=".375rem" onClick={() => handleExport(id!)}>
        <UploadOutlined height={16} width={16} />
        <Typography>Export data</Typography>
      </Flex>
    ),
  };

  switch (litigationStatus) {
    case undefined:
    case 'SOLVED':
    case 'CANCELED':
      return [
        exportDataItem,
        {
          key: '2',
          label: commonLitigationItem(
            'Flag as "Litigation"',
            'FLAG',
            onItemClick
          ),
        },
      ];
    case 'FLAGGED':
      return [
        exportDataItem,
        {
          key: '2',
          label: commonLitigationItem(
            'Cancel "Litigation"',
            'CANCEL',
            onItemClick
          ),
        },
        {
          key: '3',
          label: commonLitigationItem(
            'Flag as "Litigation solved"',
            'SOLVE',
            onItemClick
          ),
        },
      ];
    default:
      return [];
  }
};
